import React from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { FaBriefcase, FaMapMarkerAlt, FaClock, FaRupeeSign, FaEye, FaHeart, FaTrash } from "react-icons/fa";
import axios from "axios";
import { API_BASE_URL } from "../utils/config";

const SavedJobs = () => {
  const { savedJobs = [], setSavedJobs } = useOutletContext();
  const navigate = useNavigate();

  const toggleSave = async (jobId) => {
    try {
      const token = localStorage.getItem("candidateToken");
      if (!token) {
        navigate("/candidate-login");
        return;
      }
      const res = await axios.post(`${API_BASE_URL}/candidate/saved-jobs/toggle`, { jobId }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data.success) {
        const updatedRes = await axios.get(`${API_BASE_URL}/candidate/saved-jobs`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (updatedRes.data.success) {
          setSavedJobs(updatedRes.data.savedJobs);
        }
      }
    } catch (err) {
      console.error("Toggle save error:", err);
    }
  };

  return (
    <div className="w-full h-full">
      {/* Header */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 mb-8">
        <div className="flex items-center gap-4">
          <div className="p-3 bg-gradient-to-br from-red-50 to-pink-50 rounded-xl text-red-600 shadow-sm border border-red-100/50">
            <div className="w-10 h-10 rounded-full bg-gradient-to-r from-red-500 to-pink-600 flex items-center justify-center text-white shadow-md">
              <FaHeart size={20} />
            </div>
          </div>
          <div>
            <h1 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-red-500 to-pink-600">SAVED JOBS</h1>
            <div className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-0.5">Your Curated Opportunities</div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="p-0 bg-white border shadow-lg rounded-xl overflow-hidden">
        {savedJobs.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead className="text-xs text-left text-white bg-gradient-to-r from-red-500 to-pink-600">
                <tr>
                  <th className="py-3 px-4 text-center font-bold">Job Position</th>
                  <th className="py-3 px-4 text-center font-bold hidden md:table-cell">Department</th>
                  <th className="py-3 px-4 text-center font-bold hidden md:table-cell">Location</th>
                  <th className="py-3 px-4 text-center font-bold">Experience</th>
                  <th className="py-3 px-4 text-center font-bold">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {savedJobs.map((job) => (
                  <tr key={job._id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-4 py-2 text-center">
                      <div className="text-xs font-bold text-gray-800">{job.role}</div>
                      {job.jobType && (
                        <div className="text-[9px] text-gray-400 font-bold uppercase tracking-wider mt-0.5">{job.jobType}</div>
                      )}
                    </td>
                    <td className="px-4 py-2 text-center hidden md:table-cell">
                      <span className="text-[10px] font-medium text-pink-700 bg-pink-50 px-2 py-0.5 rounded uppercase tracking-wider">
                        {job.department || "General Ops"}
                      </span>
                    </td>
                    <td className="px-4 py-2 text-center hidden md:table-cell">
                      <div className="inline-flex items-center gap-1 text-[10px] font-medium text-gray-500 uppercase tracking-wider">
                        <FaMapMarkerAlt className="text-pink-400" size={10} />
                        {job.location}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-center align-middle">
                      <div className="inline-flex items-center gap-1.5 text-[10px] font-bold text-gray-500 uppercase tracking-wider bg-gray-50 px-2.5 py-1 rounded-md border border-gray-100 shadow-sm">
                        <FaClock className="text-amber-500" size={11} />
                        {job.experience || "Fresher"}
                      </div>
                    </td>
                    <td className="px-4 py-2 text-center">
                      <div className="flex flex-col sm:flex-row items-center justify-center gap-2">
                        <button
                          onClick={() => toggleSave(job._id)}
                          className="px-3 py-1 text-[9px] font-bold uppercase tracking-widest rounded-lg border bg-red-50 text-red-600 border-red-100 hover:bg-red-100 transition-all"
                        >
                          <div className="flex items-center gap-1.5">
                            <FaHeart />
                            Saved
                          </div>
                        </button>
                        <button
                          onClick={() => navigate(`/jobs/${job._id}`)}
                          className="px-3 py-1 bg-blue-600 text-white text-[9px] font-bold uppercase tracking-widest rounded-lg hover:bg-blue-700 transition-all flex items-center gap-1.5 shadow-sm"
                        >
                          <FaEye size={10} /> View and Apply
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="p-12 text-center">
            <div className="w-12 h-12 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-3 text-gray-300">
              <FaHeart size={20} />
            </div>
            <h3 className="text-sm font-bold text-gray-700 mb-1">No Saved Jobs</h3>
            <p className="text-[10px] text-gray-400 font-medium tracking-wider">You haven't saved any jobs yet. Browse jobs to add them here.</p>
            <button
              onClick={() => navigate("/all-jobs")}
              className="mt-4 px-6 py-2 bg-gradient-to-r from-red-500 to-pink-600 text-white rounded-xl text-[10px] font-bold uppercase tracking-widest shadow-md hover:opacity-90 transition"
            >
              Explore Jobs
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SavedJobs;